import { ReactNode } from 'react';
import { Root, LinkType } from './link.styles';
export interface LinkProps {
    children?: ReactNode;
    onClick?: () => void;
    text?: string;
    disabled?: boolean;
    href?: string;
    action?: boolean;
    type?: LinkType;
    newTab?: boolean;
    inline?: boolean;
}
export function Link({
    children,
    onClick,
    text,
    href,
    action = false,
    type = LinkType.NORMAL,
    newTab = false,
    inline = false,
}: LinkProps) {
    return (
        <Root
            data-test-id={`link-${text}`}
            onClick={onClick}
            href={href}
            $inline={inline}
            $isAction={action}
            $linkType={type}
            target={newTab ? '_blank' : undefined}
        >
            {text}
            {children}
        </Root>
    );
}
